// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DataTableIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DataTableIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 4.5V7h5.834A2.27 2.27 0 0 0 10 8.17V8.5H8.5v7H10v.33A2.27 2.27 0 0 0 10.334 17H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1.378a6.5 6.5 0 0 0-1.5-.339V4.5zm2.5 11v-7H4.5v7z" />
      <path d="M11 8.5V15h1.5v-1.294c.685.342 1.554.545 2.5.545s1.815-.203 2.5-.545V15c0 .01-.001.05-.057.132a1.4 1.4 0 0 1-.41.364C16.583 15.777 15.868 16 15 16s-1.583-.223-2.033-.504a1.4 1.4 0 0 1-.41-.364C12.5 15.051 12.5 15.01 12.5 15H11a1.73 1.73 0 0 0 .333 1c.617.883 2.027 1.5 3.667 1.5s3.05-.617 3.667-1.5A1.77 1.77 0 0 0 19 15V8.5C19 7.12 17.209 6 15 6s-4 1.12-4 2.5m6.443.132a1.4 1.4 0 0 1-.41.364C16.583 9.277 15.868 9.5 15 9.5s-1.584-.223-2.033-.504a1.4 1.4 0 0 1-.41-.364C12.5 8.551 12.5 8.51 12.5 8.501V8.5c0-.008 0-.049.057-.132a1.4 1.4 0 0 1 .41-.364C13.417 7.723 14.131 7.5 15 7.5s1.583.223 2.033.504a1.4 1.4 0 0 1 .41.364C17.5 8.45 17.5 8.492 17.5 8.5s0 .049-.057.132m.057 1.82v1.298h-.001c-.008.052-.062.248-.465.5-.448.28-1.162.5-2.034.5-.873 0-1.587-.22-2.034-.5-.403-.252-.457-.448-.465-.5H12.5v-1.298C13.185 10.795 14.054 11 15 11s1.815-.205 2.5-.549" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DataTableIcon = /* @__PURE__ */ Object.assign(
  DataTableIconComponent,
  { displayName: 'DataTableIcon' },
);
